module.exports = __webpack_public_path__ + "img/e_3_16_r.91856a5b.png";